<template>
  <div class="cholesterolView">
    <cholesterol-line-graph
      class="insetGraph"
      v-if="$store.state.user.scope"
      :userId="$store.state.user.scope.user_id"
    ></cholesterol-line-graph>
    <mu-row gutter v-if="$store.state.user.scope" class="content">
      <mu-col desktop="30" tablet="50" width="100">
        <cholesterol-input
          class="card-spacing bottom"
          v-if="$store.state.user.settings"
          style="margin-top: 24px"
          :blood_glucose="$store.state.user.settings.blood_glucose">
          >
        </cholesterol-input>

        <tracking-exporter
          type="cholesterol"
        ></tracking-exporter>

        <tracking-notifier
          :userId="$store.state.user.scope.user_id"
        ></tracking-notifier>
      </mu-col>
      <mu-col desktop="70" tablet="50">
        <mu-card
          style="margin-top: 24px;"
          id="blood-glucose-data"
          class="tracking-data"
        >
          <mu-card-text>
            <p class="tracking-subtext" v-text="$t('message.trackingHelpText')"></p>
            <mu-select-field v-model="activeFilter" icon="filter_list" autoWidth>
              <mu-menu-item v-for="filter, index in filters" :key="'tracking-filter-' + index" :value="filter.key"
                            :title="filter.value"></mu-menu-item>
            </mu-select-field>
          </mu-card-text>
          <mu-timeline>
            <div v-for="group, groupKey in groupFilter()" :key="'group-key-' + groupKey" style="margin-bottom: 16px;">
              <div v-for="titleItem, titleIndex in group" v-if="titleIndex === 0" class="timelineSpacing">
                <div class="bold timelineTitle"
                     v-text="groupedDateFormat(titleItem.date_created)">
                </div>
              </div>
              <div v-for="item, index in group" class="timelineSpacing" :key="'tracking-timeline-item-' + index" v-bind:class="{notEditMode: !item.isEditMode}">
                <mu-timeline-item
                  :iconColor="determineColor(item)"
                  iconLine="8"
                  iconType="solid"
                  @click.native="showItemControls(item)"
                >
                  <mu-row>
                    <mu-col>
                      <div class="trackingDate" v-if="!item.isEditMode"
                           v-text="groupedItemDate(item.date_created)"></div>
                    </mu-col>
                    <mu-col>
                      <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}"
                           class="reading">
                        <div v-if="activeFilter === 'TOTAL_CHOLESTEROL'">
                          <div
                            v-text="data.preference === 'mmoll' ? '' +item.total_mmoll + ' mmol/L' :  item.total_mgdl + ' mg/dL'"></div>
                        </div>
                        <div v-if="activeFilter === 'LDL_CHOLESTEROL'">
                          <div
                            v-text="data.preference === 'mmoll' ? '' +item.ldl_mmoll + ' mmol/L' :  item.ldl_mgdl + ' mg/dL'"></div>
                        </div>
                        <div v-if="activeFilter === 'HDL_CHOLESTEROL'">
                          <div
                            v-text="data.preference === 'mmoll' ? '' +item.hdl_mmoll + ' mmol/L' :  item.hdl_mgdl + ' mg/dL'"></div>
                        </div>
                        <div v-if="activeFilter === 'TRIGLYCERIDES'">
                          <div
                            v-text="data.preference === 'mmoll' ? '' +item.triglycerides_mmoll + ' mmol/L' :  item.triglycerides_mgdl + ' mg/dL'"></div>
                        </div>
                      </div>
                    </mu-col>
                  </mu-row>
                  <div v-if="item.isControlsVisible && !item.isEditMode" align="right">
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.editText')"
                      icon="edit"
                      @click.native="editReading(item)"
                    >
                    </mu-flat-button>
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.deleteText')"
                      icon="delete"
                      @click.native="deleteReading(item)"
                    ></mu-flat-button>
                  </div>

                  <div v-if="item.isEditMode">
                    <cholesterol-edit
                      @updateReading="updateReading"
                      @closeEditPanel="closeEditMode(item)"
                      :preference="data.preference"
                      :item="item"
                    ></cholesterol-edit>
                  </div>
                </mu-timeline-item>
              </div>
            </div>
          </mu-timeline>
          <mu-card-text align=" center" v-if="isReadingsLoading">
            <mu-circular-progress color="#0179d5"></mu-circular-progress>
            <div v-text="$t('message.loadingText')"></div>
          </mu-card-text>
          <div v-if="!isReadingsLoading" ref="detector"></div>
        </mu-card>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>

  import CholesterolApi from "../../api/Tracking/Cholesterol"
  import CholesterolEdit from "../../components/Tracking/Edit/Cholesterol/CholesterolEdit.vue";
  import TrackingDetailMixin from '../../mixins/TrackingDetailMixin'
  import CholesterolLineGraph from "../../components/Tracking/Graphs/Cholesterol/LineGraph.vue";
  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier.vue";
  import TrackingExporter from "../../components/Tracking/Exporter/Exporter.vue";

  let fromDate = moment().subtract(1, 'month');
  let toDate = moment();

  export default {
    components: {
      TrackingExporter,
      TrackingNotifier,
      CholesterolLineGraph,
      CholesterolEdit,
    },
    mixins: [TrackingDetailMixin],
    data() {
      let self = this;
      return {
        activeFilter: "TOTAL_CHOLESTEROL",
        ranges: {
          mmoll: {
            ldl: {
              value: 3
            },
            hdl: {
              value: 1
            },
            total: {
              value: 5
            }
          },
          mgdl: {
            ldl: {
              value: 54
            },
            hdl: {
              value: 18
            },
            total: {
              value: 90
            }
          }
        },
        filters: [
          {
            key: "TOTAL_CHOLESTEROL",
            value: this.$t('message.labelCholesterolTotal') + " " + this.$t('message.cardCholesterol')
          },
          {
            key: "LDL_CHOLESTEROL",
            value: this.$t('message.labelCholesterolLDL') + " " + this.$t('message.cardCholesterol')
          },
          {
            key: "HDL_CHOLESTEROL",
            value: this.$t('message.labelCholesterolHDL') + " " + this.$t('message.cardCholesterol')
          },
          {
            key: "TRIGLYCERIDES",
            value: this.$t('message.labelCholesterolTriglycerides')
          }
        ],
        btnColor: 'rgb(105,125,206)',
      }
    },
    mounted() {
      let self = this;

      self.$gtag.pageview('/tracking/cholesterol');

      self.loadData();

      self.$EventBus.$on('cholesterolPusherReceived', function () {
        self.loadData();
      });

    },
    methods: {
      updateReading(data) {
        let self = this;
        let currentReading = self.data.data.filter(function (reading) {
          return reading.progress_id === data.progress_id
        })[0];

        currentReading.date_created = data.date_created;
        currentReading.total_mmoll = data.total_mmoll;
        currentReading.total_mgdl = data.total_mgdl;
        currentReading.ldl_mmoll = data.ldl_mmoll;
        currentReading.ldl_mgdl = data.ldl_mgdl;
        currentReading.hdl_mmoll = data.hdl_mmoll;
        currentReading.hdl_mgdl = data.hdl_mgdl;
        currentReading.triglycerides_mmoll = data.triglycerides_mmoll;
        currentReading.triglycerides_mgdl = data.triglycerides_mgdl;

        self.sortItems();
      },
      deleteReading(reading) {
        let self = this;
        let swal = self.$alert;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveCholesterolItem'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return CholesterolApi.deleteCholesterolTracking(reading.progress_id, reading.tracking_id)
          }
        })
          .then(function (response) {
            let index = self.data.data.indexOf(reading);
            self.data.data.splice(index, 1);
            self.$alert({
              title: self.$t('message.labelSuccess'),
              text: self.$t('message.confirmedRemoveCholesterolItem'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            })
          }.bind(self))
          .catch(self.$alert.noop)
      },
      determineColor(reading) {
        let self = this;
        const bloodPreference = self.data.preference;
        const green = "#5FB737";
        const orange = "#FCA039";
        if (self.activeFilter === 'TOTAL_CHOLESTEROL') {
          if (bloodPreference === 'mmoll') {
            if (reading.total_mmoll < self.ranges.mmoll.total.value) {
              return green;
            }
            else {
              return orange;
            }
          }
          if (bloodPreference === 'mgdl') {
            if (reading.total_mgdl < self.ranges.mgdl.total.value) {
              return green;
            }
            else {
              return orange;
            }
          }
        }
        if (self.activeFilter === 'HDL_CHOLESTEROL') {
          if (bloodPreference === 'mmoll') {
            if (reading.hdl_mmoll < self.ranges.mmoll.hdl.value) {
              return green;
            }
            else {
              return orange;
            }
          }
          if (bloodPreference === 'mgdl') {
            if (reading.hdl_mgdl < self.ranges.mgdl.hdl.value) {
              return green;
            }
            else {
              return orange;
            }
          }
        }
        if (self.activeFilter === 'LDL_CHOLESTEROL') {
          if (bloodPreference === 'mmoll') {
            if (reading.ldl_mmoll < self.ranges.mmoll.ldl.value) {
              return green;
            }
            else {
              return orange;
            }
          }
          if (bloodPreference === 'mgdl') {
            if (reading.hdl_mgdl < self.ranges.mgdl.ldl.value) {
              return green;
            }
            else {
              return orange;
            }
          }
        }
      },
      loadData() {
        let self = this;
        self.isReadingsLoading = true;
        CholesterolApi.getCholesterolTrackingDetail(1, 15)
          .then(function (response) {
            self.data = response.data;
            self.isReadingsLoading = false;
          })
      },
      loadMoreData() {
        let self = this, page = self.data.page, pages = self.data.pages;
        if (page >= pages) {
          self.isReadingsLoading = false;
          return;
        }
        if ((page < pages)) {
          self.isReadingsLoading = true;
          page++;
          CholesterolApi.getCholesterolTrackingDetail(page, 15)
            .then(function (response) {
              self.data.page = response.data.page;
              self.data.data.push.apply(self.data.data, response.data.data);
              self.isReadingsLoading = false;
            })
        }
      }
    },
    beforeDestroy() {
      this.$EventBus.$off('cholesterolReadingAdded');
      this.$EventBus.$off('cholesterolPusherReceived');
    }
  }
</script>
<style lang="less" scoped>
  @bgBranding: rgb(105, 125, 206);
  .cholesterolView {
    .timelineSpacing {
      padding-top: 8px;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 0px;
    }
    .timelineSpacing.notEditMode:hover {
      background: fade(@bgBranding, 10%);
      cursor: pointer;
    }
    .no_tags {
      opacity: 0.7;
      font-size: 16px;
      line-height: 1.5;
      color: #9b9b9b;
    }
    .bold {
      font-weight: bold;
    }
    #blood-glucose-data .tagGroup .tag {
      padding-left: 8px;
      color: initial !important;
      font-weight: normal;
    }
    #blood-glucose-data .tagGroup .tag img {
      padding-right: 8px;
      font-weight: normal;
    }
    .whiteTitle {
      font-size: 18px !important;
      color: white !important;
    }
    .reading {
      font-size: 16px;
    }
    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
      transition: all .3s ease;
    }
    .slide-fade-leave-active {
      transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
      /* .slide-fade-leave-active below version 2.1.8 */
    {
      transform: translateX(10px);
      opacity: 0;
    }
  }


</style>



// WEBPACK FOOTER //
// Cholesterol.vue?1fd5ab2f